import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../Auth"
import { Outlet } from "react-router"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.CONNECT_WITH_TENANTS}>
			<Outlet />
		</ForbidUnlessAuthorized>
	)
}
